// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7369) return "static/chunks/7369-9feb59ea30cbb79b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "81d3b15a9c4152c7" + ".js";
};